import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {MultiOC, SCOrderCycle, SCSkuSuppliersModelExt} from "../models/s-c-order-cycle";
import {SCValidation} from "../models/s-c-validation";
import {StocksFilter} from "../../stocks/models/stocks-filter";
import {SCBack} from "../models/s-c-back-changes";
import {b} from "@angular/core/src/render3";
import {SCItemsGUID, SCScheduleTypeGUID, SupplierCardGUID} from "../models/GUID-exchange";

@Injectable()
export class SCDataExchangeService{

    private saveOrderScheduleSource = new BehaviorSubject(null);
    saveOrderScheduleCurrent = this.saveOrderScheduleSource.asObservable();

    private orderScheduleSource = new BehaviorSubject(null);
    orderScheduleCurrent = this.orderScheduleSource.asObservable();

    private allDataSource = new BehaviorSubject(null);
    allDataCurrent = this.allDataSource.asObservable();

    private validationSource = new BehaviorSubject(null);
    validationCurrent = this.validationSource.asObservable();

    private controlItemDataSource = new BehaviorSubject(null);
    controlItemDataCurrent = this.controlItemDataSource.asObservable();

    private controlItemDataSCSource = new BehaviorSubject(null);
    controlItemDataSCCurrent = this.controlItemDataSCSource.asObservable();

    private getControlItemDataSource = new BehaviorSubject(null);
    getControlItemDataCurrent = this.getControlItemDataSource.asObservable();

    private stepBackSource = new BehaviorSubject([]);
    stepBackCurrent = this.stepBackSource.asObservable();

    private stepForwardSource = new BehaviorSubject([]);
    stepForwardCurrent = this.stepForwardSource.asObservable();

    private stepBackBtnSource = new BehaviorSubject(null);
    stepBackBtnCurrent = this.stepBackBtnSource.asObservable();

    private stepForwardBtnSource = new BehaviorSubject(null);
    stepForwardBtnCurrent = this.stepForwardBtnSource.asObservable();

    private updateSupplierForSupplierCardSource = new BehaviorSubject(null);
    updateSupplierForSupplierCurrent = this.updateSupplierForSupplierCardSource.asObservable();

    private updateScheduleTypeSource = new BehaviorSubject(null);
    updateScheduleTypeCurrent = this.updateScheduleTypeSource.asObservable();

    private updateItemsOnWrhChangesSource = new BehaviorSubject(null);
    updateItemsOnWrhChangesCurrent = this.updateItemsOnWrhChangesSource.asObservable();

    constructor(){

    }

    setOrderSchedule = (param: SCOrderCycle): void =>{
        this.orderScheduleSource.next(param);
    }

    getOrderSchedule = (): SCOrderCycle =>{
        return this.orderScheduleSource.getValue();
    }

    setParameters = (data: {orderCycle: SCOrderCycle, component: string}): void =>{
        this.saveOrderScheduleSource.next(data);
    }

    getValidation = (): SCValidation =>{
        return this.validationSource.getValue();
    }

    setValidation = (data: SCValidation): void =>{
        this.validationSource.next(data);
    }

    getParameters = (): SCOrderCycle =>{
        return this.saveOrderScheduleSource.getValue();
    }

    getAllData = (): void => {
        this.allDataSource.next(true);
        this.allDataSource.next(false);
    }

    clearService = (): void => {
        this.orderScheduleSource.next(null);
        this.saveOrderScheduleSource.next(null);
        this.validationSource.next(null);
        this.allDataSource.next(null);
        this.controlItemDataSource.next(null);
        this.controlItemDataSCSource.next(null);
        this.getControlItemDataSource.next(null);
        this.stepBackSource.next([]);
        this.stepForwardSource.next([]);
        this.stepBackBtnSource.next(null);
        this.stepForwardBtnSource.next(null);
        this.updateSupplierForSupplierCardSource.next(null)
    }

    setGetControlItemData = (data: {GUID: string, param: string, filter: StocksFilter}): void =>{
        this.getControlItemDataSource.next(data);
    };

    setControlItemData = (data: SCItemsGUID): void =>{
        this.controlItemDataSource.next(data);
    };

    getControlItemData = (): SCItemsGUID => {
        return this.controlItemDataSource.getValue();
    };

    setControlItemDataSC = (data: SCItemsGUID): void =>{
        this.controlItemDataSCSource.next(data);
    };

    getControlItemDataSC = (): SCItemsGUID => {
        return this.controlItemDataSCSource.getValue();
    };

    setStepBackData = (data: SCBack): void =>{
        let allData: SCBack[] = this.getStepBackData();
        allData.push(data);
        this.stepBackSource.next(allData);
    };

    remLastStepBackData = (): void =>{
        let allData: SCBack[] = this.getStepBackData();
        allData.splice(allData.length - 1, 1);
        this.stepBackSource.next(allData);
    };

    getStepBackData = (): SCBack[] => {
        return this.stepBackSource.getValue();
    };

    clearStepBackData = (): void => {
        this.stepBackSource.next([]);
    };

    setStepForwardData = (data: SCBack): void =>{
        let allData: SCBack[] = this.getStepForwardData();
        allData.push(data);
        this.stepForwardSource.next(allData);
    };

    remLastStepForwardData = (): void =>{
        let allData: SCBack[] = this.getStepForwardData();
        allData.splice(allData.length - 1, 1);
        this.stepForwardSource.next(allData);
    };

    remAllStepForwardData = (): void =>{
        this.stepForwardSource.next([]);
    };

    getStepForwardData = (): SCBack[] => {
        return this.stepForwardSource.getValue();
    };

    setStepBackBtnData = (data: boolean): void =>{
        this.stepBackBtnSource.next(data);
    };

    setStepForwardBtnData = (data: boolean): void =>{
        this.stepForwardBtnSource.next(data);
    };

    setSupplierForSC = (data: SupplierCardGUID): void =>{
        this.updateSupplierForSupplierCardSource.next(data);
    };

    getSupplierForSC = (): SupplierCardGUID => {
        return this.updateSupplierForSupplierCardSource.getValue();
    };

    setScheduleType = (data: SCScheduleTypeGUID): void =>{
        this.updateScheduleTypeSource.next(data);
    };

    updateItemsOnWrhChanges = (data: {cycles: MultiOC[], stepBack: boolean}): void =>{
        this.updateItemsOnWrhChangesSource.next(data);
        this.updateItemsOnWrhChangesSource.next(null);
    };


}




// WEBPACK FOOTER //
// ./src/app/supply-schedules/services/s-c-data-exchange.service.ts